export default "__VITE_ASSET__RStKr0$GLnvej6C6BLO2SA__"